import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getOvercomingStatistics } from './queries/queries';
import { InfoCardWidget } from '../../../../statisticsWidgets/statisticsWidgets';
import DataProcessor from '../../common/dataProcessors/overcomingDataProcessor';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class Overcoming extends BaseWidget {
  get statisticsData() {
    return { membersCount: this.props.data.statistics.churchManager.church.daily.overcomingRecordsSubmitted };
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'day');
  }

  render() {
    return (
      <InfoCardWidget primaryColor="#ff9500" secondaryColor="#595959" icon="icon-mountain" title="Daily Overcoming"
                      data={this.dataProcessor.data} loading={this.props.data.loading}
                      comment={this.comment}/>
    );
  }
}

export default compose(
  graphql(getOvercomingStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(Overcoming);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/daily/overcoming.js